module.exports = __webpack_public_path__ + "static/006.thumb-ddea50ea95f19bcf6df83b9095c6b1d4.jpg";